import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const FormSelect = ({
  label,
  icon,
  options = [],
  required = false,
  disabled = false,
  value = "",
  onChange = () => { },
  name = "",
  error = "",
  className = "",
  selectClassName = "",
  labelClassName = "",
  groupClassName = "",
  placeholder,
}) => {
  return (
    <div className={clsx("form-group", groupClassName)}>
      {label && (
        <label className={clsx("form-label text-muted", labelClassName)}>
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div className={clsx("input-group", className)}>
        {icon && (
          <span className="input-group-text">
            <i className={icon}></i>
          </span>
        )}

        <select
          name={name}
          value={value}
          disabled={disabled}
          onChange={onChange}
          className={clsx("form-select", selectClassName, {
            "is-invalid": error,
          })}
        >
          <option value="" disabled>
            {placeholder || (label ? `Choose ${label}` : "Select an option")}
          </option>
          {options.length > 0 ? (
            options.map((opt, idx) => (
              <option key={idx} value={opt.value}>
                {opt.label}
              </option>
            ))
          ) : (
            <option value="" disabled>
              No options available
            </option>
          )}
        </select>
      </div>

      {error && <div className="invalid-feedback">{error}</div>}
    </div>
  );
};

FormSelect.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
    })
  ),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.string,
  error: PropTypes.string,
  className: PropTypes.string,
  selectClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  groupClassName: PropTypes.string,
  placeholder: PropTypes.string, 
};


export default FormSelect;
